export default __webpack_public_path__ + "static/media/gall3.8b04ba1b.jpg";